"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CurrencyPgHandler", {
    enumerable: true,
    get: function() {
        return CurrencyPgHandler;
    }
});
const _decimalpghandler = require("../decimal/decimal.pg.handler");
const _currencygeneralhandler = require("./currency.general.handler");
let CurrencyPgHandler = class CurrencyPgHandler extends _decimalpghandler.DecimalPgHandler {
    constructor(...args){
        super(...args), this.currencyGeneralHandler = new _currencygeneralhandler.CurrencyGeneralHandler(), this.parseUserInput = this.currencyGeneralHandler.parseUserInput;
    }
};
